<template>
    <nav class="main-menu" :class="{ 'active': $store.state.mainMenu.status }">
        <a href="#overview" class="nav-item" data-scroll>{{ $t('Overview') }}</a>
        <a href="#gallery" class="nav-item" data-scroll>{{ $t('Gallery') }}</a>
        <a href="#reviews" class="nav-item" data-scroll>{{ $t('Reviews') }}</a>
        <a href="#facilities" class="nav-item" data-scroll>{{ $t('Facilities') }}</a>
        <a href="#location" class="nav-item" data-scroll>{{ $t('Location') }}</a>
        <a href="#contact" class="nav-item" data-scroll>{{ $t('Contact') }}</a>
        <a href="#book" class="nav-item" data-scroll>{{ $t('Book') }}</a>

        <slot name="footer"></slot>
    </nav>
</template>

<script>
export default {}
</script>
